<template>
  <div class="keyboard-popup">
    <keyboard-svg-wrapper :keys="$data.keys" />

    <div class="-options">
      <div
        class="-option"
        @mouseenter="$_setKeys(['key-a'])"
        @mouseleave="$_resetKeys"
      >
        <div>Add segment to your video</div>
        <img :src="ShortcutAUrl" alt="a" />
      </div>

      <div
        class="-option"
        @mouseenter="$_setKeys(['key-i', 'key-o'])"
        @mouseleave="$_resetKeys"
      >
        <div>Select segment: in / out</div>
        <img :src="ShortcutIOUrl" alt="io" />
      </div>

      <div
        class="-option"
        @mouseenter="$_setKeys(['key-larrow', 'key-rarrow'])"
        @mouseleave="$_resetKeys"
      >
        <div>Assets: previous / next</div>
        <img :src="ShortcutArrowsUrl" alt="arrows" />
      </div>

      <div
        class="-option"
        @mouseenter="$_setKeys(['key-lsb', 'key-rsb'])"
        @mouseleave="$_resetKeys"
      >
        <div>Frames: previous / next</div>
        <img :src="ShortcutSquareBracketsUrl" alt="arrows" />
      </div>

      <div
        class="-option"
        @mouseenter="$_setKeys(['key-rshift', 'key-larrow', 'key-rarrow'])"
        @mouseleave="$_resetKeys"
      >
        <div>Scenes: previous / next</div>
        <img :src="ShortcutShiftArrowsUrl" alt="shift arrows" />
      </div>

      <div
        class="-option"
        @mouseenter="$_setKeys(['key-space'])"
        @mouseleave="$_resetKeys"
      >
        <div>Play / Pause</div>
        <img :src="ShortcutSpaceUrl" alt="space" />
      </div>
    </div>
  </div>
</template>

<script>
import KeyboardSvgWrapper from './KeyboardSvgWrapper.vue';
import ShortcutAUrl from './svg/shortcut-a.svg';
import ShortcutSquareBracketsUrl from './svg/shortcut-square-brackets.svg';
import ShortcutArrowsUrl from './svg/shortcut-arrows.svg';
import ShortcutIOUrl from './svg/shortcut-io.svg';
import ShortcutShiftArrowsUrl from './svg/shortcut-shift-arrows.svg';
import ShortcutSpaceUrl from './svg/shortcut-space.svg';

export default {
  name: 'KeyboardPopup',
  components: {
    KeyboardSvgWrapper,
  },

  data() {
    return {
      keys: [],
      ShortcutAUrl,
      ShortcutSquareBracketsUrl,
      ShortcutArrowsUrl,
      ShortcutIOUrl,
      ShortcutShiftArrowsUrl,
      ShortcutSpaceUrl,
    };
  },

  methods: {
    $_setKeys(keys) {
      this.$data.keys = keys;
    },

    $_resetKeys() {
      this.$data.keys = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.keyboard-popup {
  width: 320px;
  padding: 20px 0 6px 0;

  > .-options {
    margin-top: 30px;

    .-option {
      height: 40px;
      padding: 0 20px 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: default;

      &:hover {
        background-color: rgba($color-primary, 0.1);
      }
    }
  }
}
</style>
